export default __webpack_public_path__ + "static/media/learose5-1440w.0f0fc681.avif";